export default class Seniority {
  id: string;

  name: string;

  constructor(obj: any) {
    this.id = obj.id || null;
    this.name = obj.name || null;
  }

  public static of(obj: any): Seniority {
    return new Seniority(obj || {});
  }

  public static ofList(obj: any[]): Seniority[] {
    return obj.map(this.of);
  }
}
